import styled from "styled-components";

const LocateStyles = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* min-width: 1145px; */
  background-color: #f2ede3;

  .mobile-instructions {
    display: none;
  }

  .filters {
    width: 360px;
    min-width: 360px !important;
    background-color: #f2ede3;
    overflow: hidden;
    /* box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.1); */
    /* clip-path: inset(0px -12px 0px 0px); */
    z-index: 10;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .results {
    /* overflow: hidden; */
    height: 100vh;
    width: calc(100% - 360px);
    /* background-color: lightslategray; */
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    min-width: 785px !important;
  }

  .num-of-results {
    position: absolute;
    top: 20px;
    left: calc((100% - 412px) / 2);
    transform: translateX(-50%);
    background-color: white;
    box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 100px;
    padding: 12px 24px 12px 18px;
    z-index: 100;
    font-size: 16px;

    &-text {
      display: inline-block;
    }
  }

  .num-of-filters-text {
    display: inline-block;
    margin-right: 16px;
    background: var(--light-gray);
    padding: 3px 20px 4px 14px;
    border-radius: 30px;
  }

  .num-of-filters-text--mobile {
    display: inline-block;
    background: var(--neon-yellow);
    padding: 4px 18px 6px !important;
    font-size: 16px !important;
    border-radius: 30px;
    box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
    line-height: 30px !important;
    margin-bottom: 8px;
  }

  .close-icon {
    margin-right: 10px;
    position: relative;
    bottom: -1px;
    cursor: pointer;
  }

  @media only screen and (max-width: 1145px) and (pointer: coarse) {
    min-width: initial !important;
    width: 100%;
    background: var(--off-black);

    .mobile-filter-btn {
      font-family: var(--header-font-bold);
      font-size: 20px;
      /* width: calc(100vw - 24px); */
      background-color: var(--neon-yellow);
      color: var(--off-black);
      display: inline-block;
      border-radius: 30px;
      margin-top: 30px;
      margin-left: 12px;
      text-align: left;
      padding: 0 70px 0 30px;
      cursor: pointer;
      box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.07);
      position: relative;
      line-height: 51px;

      span {
        font-size: 16px;
      }

      &__container {
        text-align: center;
      }
    }

    .filter-icon {
      position: absolute;
      display: inline-block;
      height: 12px;
      width: 12px;
      right: 35px;
      top: 5px;
    }
    /* position: relative; */
    .filter-sort-bar__instructions-2 {
      color: white;
      text-align: center;
      font-size: 18px !important;
      padding: 0 20px !important;
      margin: 0 auto;
    }

    .mobile-instructions {
      display: block;
      margin-top: 40px;

      h1 {
        font-family: var(--header-font) !important;
        font-weight: normal !important;
        font-size: 32px;
        margin-bottom: 8px;
        line-height: 36px;
        padding: 0 12px;
        text-align: center;
        color: white;
      }

      p {
        font-size: 16px;
        line-height: 22px;
        max-width: 400px;
        padding: 0 12px;
      }
    }

    .mobile-filters {
      height: 100%;
      width: 100vw;
      background-color: #f2ede3;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99999;
      overflow-y: scroll;
      padding: 12px;
    }

    .filters {
      display: none;
    }

    .results {
      position: relative;
      display: block;
      width: 100vw;
      height: 100%;
      min-width: initial !important;
    }

    .num-of-results {
      position: relative;
      top: initial;
      left: initial;
      transform: translateX(0);
      box-shadow: none;
      border-radius: 0;
      width: calc(100vw - 24px);
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding: 30px 24px 12px 0px;
      margin: 20px 12px 0;
      color: white;
      /* border-bottom: 2px solid var(--light-gray);
       */
      background-color: var(--off-black);
    }

    .num-of-filters-text {
      display: none;
    }
  }
`;

export default LocateStyles;
